/**
 * @generated SignedSource<<44bf6dd04feb4368e567206e373ae4c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ToggleBlockFieldField = "DONE" | "WONT_DO";
export type ToggleBlockFieldInput = {
  clientMutationId?: string | null;
  field: ToggleBlockFieldField;
  noteBlockId?: string | null;
  noteBlockKey?: string | null;
  noteId?: string | null;
  value: boolean;
};
export type assignableToggleFieldDoneMutation$variables = {
  input: ToggleBlockFieldInput;
};
export type assignableToggleFieldDoneMutation$data = {
  readonly toggleBlockField: {
    readonly ok: boolean;
  } | null;
};
export type assignableToggleFieldDoneMutation = {
  response: assignableToggleFieldDoneMutation$data;
  variables: assignableToggleFieldDoneMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToggleBlockFieldPayload",
    "kind": "LinkedField",
    "name": "toggleBlockField",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "assignableToggleFieldDoneMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assignableToggleFieldDoneMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "741b2eb38a1cfccccac1ff03bc26f4b6",
    "id": null,
    "metadata": {},
    "name": "assignableToggleFieldDoneMutation",
    "operationKind": "mutation",
    "text": "mutation assignableToggleFieldDoneMutation(\n  $input: ToggleBlockFieldInput!\n) {\n  toggleBlockField(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "ade1200cfd8406ee63829db08b5cac21";

export default node;
